import buildCorrectGrammarText from "Common/componentUtils/buildCorrectGrammarText";
import join from "lodash/join";
import map from "lodash/map";
const buildSubstring = (id, name) => `${name ? `"${name}" (${id})` : `"${id}"`}`;
export default {
    noDocumentObjectAttributes: (documentObjectId, documentObjectName) => `Нет атрибутов для объекта ${buildSubstring(documentObjectId, documentObjectName)}`,
    noTransformInputTypes: (transformId, transformName) => `Не указаны типы объектов для запуска метода ${buildSubstring(transformId, transformName)}`,
    invalidTransformInputTypes: (transformId, transformName, invalidInputTypes) => `${buildCorrectGrammarText(invalidInputTypes.length, [
        "Указан несуществующий тип",
        "Указаны несуществующие типы",
        "Указаны несуществующие типы"
    ])} ${join(map(invalidInputTypes, t => `"${t}"`), ", ")} для запуска метода ${buildSubstring(transformId, transformName)}`,
    invalidTransformInputFields: (transformId, transformName, invalidInputFields) => `${buildCorrectGrammarText(invalidInputFields.length, [
        "Указано несуществующее входное поле",
        "Указаны несуществующие входные поля",
        "Указаны несуществующие входные поля"
    ])} ${join(map(invalidInputFields, f => `"${f}"`), ", ")} для запуска метода ${buildSubstring(transformId, transformName)}`,
    noTransformOutputTypes: (transformId, transformName) => `Не указаны типы объектов, получаемые в результате выполнения метода ${buildSubstring(transformId, transformName)}`,
    invalidTransformOutputTypes: (transformId, transformName, invalidOutputTypes) => `${buildCorrectGrammarText(invalidOutputTypes.length, [
        "Указан несуществующий тип",
        "Указаны несуществующие типы",
        "Указаны несуществующие типы"
    ])} ${join(map(invalidOutputTypes, t => `"${t}"`), ", ")} ${buildCorrectGrammarText(invalidOutputTypes.length, [
        "объекта, получаемого",
        "объектов, получаемых",
        "объектов, получаемых"
    ])} в результате выполнения метода ${buildSubstring(transformId, transformName)}`
};
